import React from 'react'
import PropTypes from 'prop-types'

const PlayCircleIcon = React.memo(({ fill, stroke }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="47" height="47" viewBox="0 0 47 47">
        <g id="Group_439" data-name="Group 439" transform="translate(-821 -983)">
            <g id="Ellipse_134" data-name="Ellipse 134" transform="translate(821 983)" fill="none" stroke={stroke} strokeWidth="2">
            <circle cx="23.5" cy="23.5" r="23.5" stroke="none"/>
            <circle cx="23.5" cy="23.5" r="22.5" fill="none"/>
            </g>
            <path id="Polygon_1" data-name="Polygon 1" d="M6.5,0,13,11H0Z" transform="translate(851 1001) rotate(90)" fill={fill}/>
        </g>
    </svg>
  )
})

PlayCircleIcon.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string
}

PlayCircleIcon.defaultProps = {
  fill: "#FFF",
  stroke: "#FFF"
}

export {PlayCircleIcon}